import React ,{ useState,useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Button, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from "src/components/DatePicker";
import Operarios from 'src/services/operarios';


const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '25ch',
      },
    },
    holyday:{
        textAlign:'center',
        fontWeight: 'bold',
        width: '100%',
        background: '#800c24',
        padding: '15px',
        color: 'white'
    },
    input: {
      '& > *': {
        marginLeft: theme.spacing(4),
        width: '25ch',
        justifyContent: "center",
        alignItems: "center",
        textAlign: '100%',
      },
    }
  }));
  

  const dias = [
    {
      value: '',
      label: ''
    },
    {
      value: 'Lunes',
      label: 'Lunes'
    },
    {
      value: 'Martes',
      label: 'Martes'
    },
    {
      value: 'Miercoles',
      label: 'Miercoles'
    },
    {
      value: 'Jueves',
      label: 'Jueves'
    },
    {
      value: 'Viernes',
      label: 'Viernes'
    },
    {
      value: 'Sabado',
      label: 'Sabado'
    },
    {
      value: 'Domingo',
      label: 'Domingo'
    }
  ]
  

const DiaLibre = () => {

    const classes = useStyles();

    //A continuacion declaramos los estados:

    //searchValue
    const [searchValue, setSearchValue] = useState('');
    //opciones
    const [diaLibre, setDiaLibre] = useState('');
    //respuesta dia libre
    const [diaResponse, setDiaResponse] = useState<any>('');
    //legajo 
    const [legajo, setLegajo] = useState();
    //operario id 
    const [operarioId, setOperarioId] = useState('');
    //Fecha Inicio
    const [Fecha, setFecha] = useState<Date | undefined>(new Date());
    //configurar hooks
    const [operarios, setOperarios] = useState<any>([{}]);
    //estado para crear dia libre
    const [datosJson, setDatosJson] = useState<any>(JSON);

     useEffect(() => {
      (async () => {
       await loadOperario();
      })();
    }, []);

    const loadOperario = async () => {
    const url = await Operarios.listarOperarios();
    const response = url;
    setOperarios(response);
  };

    //searchReference(se entrega el resultado de la busqueda en "setSearchValue")
    const handleBlur = (event) => {
      const targetValue = event.nativeEvent.target.defaultValue;
      setSearchValue(targetValue);
    };

    function handleChange(e) {
      // Aquí puedes manejar una solicitud fetch para traer los valores
      const nombreOperario = e.target.textContent;
      sessionStorage.setItem('legajo', nombreOperario)
      const datos = { legajo: nombreOperario };
    
      Operarios.diaLibreOperario(datos)
      .then((response) => {
        const url = response.data;
      if(!Array.isArray(url)){
        setLegajo(nombreOperario)
      }
        if (Array.isArray(url)) {
          const datoDiaLibre = url.map((dato) => {
            return dato.diario;
          });
          setDiaResponse(datoDiaLibre);
          setLegajo(nombreOperario);
          setOperarioId(url[0]?.operario);
          
        } else {
          setDiaResponse(response.data.error);
        }
      })
      .catch((error) => {
        console.log('Ocurrió un error:', error);
      });
    }

    useEffect(() => {
      setDatosJson((prevDatosJson) => ({
        ...prevDatosJson,
        dia: diaLibre,
        legajo: legajo,
        fecha_inicio: Fecha?.toISOString().substring(0, 10),
        op_id: operarioId
      }));
    }, [diaLibre, legajo, Fecha, operarioId]);

    const handleChangeOpciones = (event) => {
      const selectedDiaLibre = event.target.value;
      setDiaLibre(selectedDiaLibre);
    };

    const handleClick =  () =>{
      setDatosJson({
        dia: diaLibre,
        legajo: legajo,
        fecha_inicio: Fecha?.toISOString().substring(0, 10),
       
      }); 
      if (!datosJson.legajo) {
        setDatosJson({
          ...datosJson,
          legajo: legajo
        });
      }
      if ( diaLibre && Fecha) {
      } else {
        // Si falta alguno de los valores, mostrar un mensaje de error o realizar alguna acción apropiada
        console.log('Por favor, complete todos los campos');
      }
    
      Operarios.crearDiaLibre(datosJson)
      .then((response) => {
        if(response.status === 200) {
          alert(response.data.info)
          const datos = sessionStorage.getItem('legajo');
          Operarios.diaLibreOperario({'legajo': datos})
          .then((response) => {
            const url = response.data;
            if (Array.isArray(url)) {
              const datoDiaLibre = url.map((dato) => {
                return dato.diario;
              });
              setDiaResponse(datoDiaLibre);
              
            } else {
              setDiaResponse(response.data.error);
            }
          })
          .catch((error) => {
            console.log('Ocurrió un error:', error);
          });
          setDiaLibre('')
        }else
        { alert(response.data.error)
          
          setDiaLibre('')
        }
      })
      .catch((error) => {
        console.log('Ocurrió un error:', error);
      })
      .finally(() => {
        setSearchValue('');
      });
    }
    
  return (
    <div>
    <Typography className={classes.holyday}>
        Datos del Operario
    </Typography>  
    <form  noValidate autoComplete="off">
              <Autocomplete
                freeSolo               
                id="solo"
                onBlur={handleBlur}
                disableClearable
                onChange={handleChange}
                options={operarios.map(
                  (datos) => `${datos.nombre} - ${datos.legajo}`
                )}
                renderInput={(params) => (
                  <TextField
                  className={classes.input}
                    {...params}
                    required
                    value={searchValue}
                    label="Buscar Operario"
                    margin="normal"
                    variant="outlined"
                    InputProps={{ ...params.InputProps, type: "search" }}
                  />
                )}
              />

              <TextField className={classes.input} value={diaResponse} id="outlined-basic" label="Dia Libre Activo" variant="outlined" disabled />
              
              <TextField
               id="outlined-select-currency-native"
               select
               required
               label="Elige dia libre nuevo"
               value={diaLibre}
               className={classes.input}
               onChange={handleChangeOpciones}
               SelectProps={{
                 native: true,
               }}
             
               variant="outlined"
               >
               {dias.map((option) => (
                 <option key={option.value} value={option.value}>
                   {option.label}
                 </option>
               ))}
              </TextField>

              <DatePicker
                  className={classes.input}
                  value={Fecha}
                  placeholder="Fecha"
                  setValue={(date) => setFecha(date || undefined)}
              />
              <Button color='primary' onClick={handleClick} variant='contained' style={{marginLeft:'60%', marginBottom:'5%'}} disabled={!diaLibre || !Fecha}>Confirmar</Button>
              
    </form>
    </div>
   
  )
}

export default DiaLibre

